import { CouponState, ExchangeState, ICashCouponInfo  } from '../type';
import { CouponButtonType, CouponTipsType, CouponType } from '@tencent/wphk-act-base-ui';
import { i18n } from '../i18n/index';
import { UtilsTypes } from '@tencent/wphk-act-base-types';

export const getStampText = (coupon: ICashCouponInfo, lang?: string) => {
  console.log('=====lang', lang);
  /** 郵戳文案配置 */
  const STAMP_TEXT_CONF = {
    RECEIVED: i18n('已領取'),
    EXPIRED: i18n('已過期'),
    USED: i18n('已使用'),
  };
  if (isCouponExpired(coupon.couponState)) {
    return STAMP_TEXT_CONF.EXPIRED;
  }
  if (isCouponUsed(coupon.couponState)) {
    return STAMP_TEXT_CONF.USED;
  }
  if (isCouponReceived(coupon.couponState)) {
    return STAMP_TEXT_CONF.RECEIVED;
  }
  return '';
};

// 后面规划：先针对场景format couponState, 保证入参只是CouponState
// 这三个函数后面需要结合formatCoupon优化
// check用户券是否已过期
// /* 状态 */
// couponState: CouponState;
// // /** 是否展示右上角用户券状态 */
// // isShowStateStamp?: boolean;
// /** 过期时间 */
// expireTime?: string;
// /** 用户券id */
// userCouponid?: string;

/**
 * 券面是否使用灰色背景
 * 灰色券的定義：就是再也無法操作，任何條件都無法用了。
 * 有顏色的話，是指在流程的步驟中的狀態。
 */
// eslint-disable-next-line arrow-body-style
export const isCouponBackgroundDisabled = (couponState?: CouponState) => {
  return isCouponExpired(couponState) || isCouponUsed(couponState);
};

export const isCouponExpired = (couponState?: CouponState) => couponState === CouponState.expired;

export const isCouponUsed = (couponState?: CouponState) => couponState === CouponState.used;

export const isCouponReceived = (couponState?: CouponState) => couponState === CouponState.received;

/** 检查兑换状态是否未开启 */
export const isNotStarted = (exchangeState?: ExchangeState) => exchangeState === ExchangeState.notStarted;
/** 检查兑换状态为可兑换 */
export const isAvaliable = (exchangeState?: ExchangeState) => exchangeState === ExchangeState.avaliable;
/** 检查兑换状态是否为今日已领完 */
export const isDayLimit = (exchangeState?: ExchangeState) => exchangeState === ExchangeState.dayLimit;
/** 检查兑换状态是否为售罄 */
export const isTotalLimit = (exchangeState?: ExchangeState) => exchangeState === ExchangeState.totalLimit;
/** 检查兑换状态是否为用户总领取上限 */
export const isTotalUserLimit = (exchangeState?: ExchangeState) => exchangeState === ExchangeState.totalUserLmit;
/** 检查兑换状态是否为用户月领取上限 */
export const isMonthUserLimit = (exchangeState?: ExchangeState) => exchangeState === ExchangeState.monthUserLimit;

export const getIsShowButton = (coupon: ICashCouponInfo) => {
  const { couponState, isShowButton, isShowUseBtn } = coupon;
  /**
   * 1. 已使用
   * 2. 已过期
   * 3. 已领取&不去使用
   */
  if (isCouponUsed(couponState) || isCouponExpired(couponState) || (isCouponReceived(couponState) && !isShowUseBtn)) {
    return false;
  }
  return Boolean(isShowButton);
};

export const getCouponBtnText = (coupon: ICashCouponInfo) => {
  const USE_BTN_TEXT = {
    TO_RECEIVE: i18n('領取'),
    TO_USE: i18n('去使用'),
  };
  const btnText = isCouponReceived(coupon.couponState) ? USE_BTN_TEXT.TO_USE : USE_BTN_TEXT.TO_RECEIVE;
  return coupon.couponBtnText || btnText;
};

export const getButtonType = (coupon: ICashCouponInfo) => {
  const { couponState, exchangeState } = coupon;
  // 兑换未开始，展示lock类型的按钮，注： V2删除
  if (isNotStarted(exchangeState)) {
    return CouponButtonType.lock;
  }
  // 今日已领完 已售罄 用户总领取上限 用户月领取上限，展示禁用类型的按钮
  if (
    isTotalLimit(exchangeState) ||
    isDayLimit(exchangeState) ||
    isTotalUserLimit(exchangeState) ||
    isMonthUserLimit(exchangeState)
  ) {
    return CouponButtonType.disabled;
  }
  // 若已获取，展示白底类型按钮
  if (isCouponReceived(couponState)) {
    return CouponButtonType.weaken;
  }
  return CouponButtonType.default;
};

/** 获取基础coupon组件底部右侧的提示文案，tipsTextRight 文案 */
export const getTipsTextRight = (coupon: ICashCouponInfo) => {
  const { exchangeState } = coupon;
  let tipsTextRight = '';
  if (isAvaliable(exchangeState) && coupon.availablePercent) {
    tipsTextRight = coupon.availablePercentText || i18n('剩餘x%可領', { availablePercent: coupon.availablePercent });
  }
  if (isDayLimit(exchangeState)) {
    tipsTextRight = coupon.dayLimitText || i18n('今日已領完');
  }
  if (isTotalLimit(exchangeState)) {
    tipsTextRight = coupon.totalLimitText || i18n('券已兌罄，無法兌換');
  }
  if (isTotalUserLimit(exchangeState)) {
    tipsTextRight = coupon.totalUserLimitText || i18n('兌換已達上限');
  }
  if (isMonthUserLimit(exchangeState)) {
    tipsTextRight = coupon.monthUserLimitTex || i18n('兌換達月上限');
  }

  return tipsTextRight;
};

/** 获取券面左下角tips的类型与文案 */
export const getTipsLeftConfig = (coupon: ICashCouponInfo) => {
  let tipsLeftConfig = {};
  if (coupon.isSpCoupon) {
    tipsLeftConfig = {
      tipsText: i18n('須手動啟用'),
      tipsType: CouponTipsType.manual,
    };
  }
  if (coupon.isChainCoupon) {
    tipsLeftConfig = {
      tipsText: i18n('須手動啟用'),
      tipsType: CouponTipsType.chain,
    };
  };
  return tipsLeftConfig;
};

/** 獲取券包信息配置 */
export const getPkgCouponInfo = (isPkgCoupon?: boolean, pkgCount = 0) => {
  const pkgCouponInfo = isPkgCoupon
    ? {
      pkgInfo: i18n('總值'),
      pkgCount, // V2新增
    }
    : {};
  return pkgCouponInfo;
};

/** 格式化折扣 */
export const getFormattedDiscount = (coupon: ICashCouponInfo, lang: UtilsTypes.LanguageTypeEnum) => {
  const discount = Number(coupon.discount);
  if (coupon.couponType !== CouponType.discount) {
    return discount;
  }
  if (lang === 'en') {
    return 100 - discount;
  }
  return discount / 10;
};
